import CheckBoxTree from './CheckBoxTree'

export default CheckBoxTree
